var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircleBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#054CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5.5 8.786 7 10.5l3.5-4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#054CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13"
})));
export { SvgCheckCircleBlue as ReactComponent };
export default __webpack_public_path__ + "static/media/checkCircleBlue.afd78c69.svg";